import { create } from "zustand";

type Callback = (...args: unknown[]) => void;

interface PubSubState {
  listeners: Record<string, Callback[]>;
  subscribe: (event: string, cb: Callback) => () => void;
  publish: (event: string, ...args: unknown[]) => void;
}

export const usePubSubStore = create<PubSubState>((set, get) => ({
  listeners: {},
  subscribe: (event, cb) => {
    set((state) => ({
      listeners: {
        ...state.listeners,
        [event]: [...(state.listeners[event] || []), cb],
      },
    }));
    // Retorna unsubscribe automático
    return () => {
      set((state) => ({
        listeners: {
          ...state.listeners,
          [event]: (state.listeners[event] || []).filter((fn) => fn !== cb),
        },
      }));
    };
  },
  publish: (event, ...args) => {
    const cbs = get().listeners[event] || [];
    cbs.forEach((cb) => cb(...args));
  },
}));